module.exports = __webpack_public_path__ + "static/img/413.dfe765e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/413.jpg
// module id = QQ9Y
// module chunks = 0